module.exports = __webpack_public_path__ + "img/lr_16.30da32b5.png";